export default function LoadingSpinner() {
  return (
    <div className="oca-spinner-wrap">
      <div className="oca-spinner" />
    </div>
  );
}
